function Sidebar({ currentPage, onNavigate, username, onLogout, appName }) {
  return (
    <aside className="sidebar">
      <div className="sidebar-header">
        <svg width="32" height="32" viewBox="0 0 48 48" fill="none">
          <rect width="48" height="48" rx="12" fill="#4361ee"/>
          <circle cx="24" cy="24" r="8" stroke="white" strokeWidth="2" fill="none"/>
          <circle cx="24" cy="24" r="3" fill="white"/>
          <line x1="24" y1="10" x2="24" y2="16" stroke="white" strokeWidth="2"/>
          <line x1="24" y1="32" x2="24" y2="38" stroke="white" strokeWidth="2"/>
          <line x1="10" y1="24" x2="16" y2="24" stroke="white" strokeWidth="2"/>
          <line x1="32" y1="24" x2="38" y2="24" stroke="white" strokeWidth="2"/>
        </svg>
        <span className="sidebar-title">{appName}</span>
      </div>

      <nav className="sidebar-nav">
        <button
          className={`sidebar-item ${currentPage === 'analyze' ? 'active' : ''}`}
          onClick={() => onNavigate('analyze')}
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="3" y="3" width="18" height="18" rx="2"/>
            <circle cx="8.5" cy="8.5" r="1.5"/>
            <path d="M21 15l-5-5L5 21"/>
          </svg>
          Analizar Imagen
        </button>
        <button
          className={`sidebar-item ${currentPage === 'config' ? 'active' : ''}`}
          onClick={() => onNavigate('config')}
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="3"/>
            <path d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 010 2.83 2 2 0 01-2.83 0l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-4 0v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83-2.83l.06-.06A1.65 1.65 0 004.68 15a1.65 1.65 0 00-1.51-1H3a2 2 0 010-4h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 012.83-2.83l.06.06A1.65 1.65 0 009 4.68a1.65 1.65 0 001-1.51V3a2 2 0 014 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 2.83l-.06.06A1.65 1.65 0 0019.4 9a1.65 1.65 0 001.51 1H21a2 2 0 010 4h-.09a1.65 1.65 0 00-1.51 1z"/>
          </svg>
          Configuración
        </button>
      </nav>

      <div className="sidebar-footer">
        <div className="sidebar-user">
          <div className="user-avatar">{username?.charAt(0).toUpperCase()}</div>
          <span>{username}</span>
        </div>
        <button className="sidebar-logout" onClick={onLogout} title="Cerrar sesión">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4"/>
            <polyline points="16 17 21 12 16 7"/>
            <line x1="21" y1="12" x2="9" y2="12"/>
          </svg>
        </button>
      </div>
    </aside>
  );
}

export default Sidebar;
